import { useRetrieveAccessory } from '../../api';

export default function GetAccessoryName(props: { id: number }) {
    const { data: accessoryData } = useRetrieveAccessory(
        props.id ? props.id.toString() : ''
    );
    return <span>{accessoryData?.data.name}</span>;
}
